import { ScrollView } from "../ScrollView.js";
import { IScrollViewWheel } from "./IScrollViewWheel.js";

export class ScrollViewWheelScroll implements IScrollViewWheel {
    public apply(view: ScrollView, deltaY: number, event: WheelEvent): void {

        var t = view.getTransformTarget();
        // view.y -= deltaY * 30;
        t.y -= deltaY * 100;
        view.setTransformClamped(t, 0.3);
    }
}